import Rx from 'rx';
import angular from 'angular';

export default function Store() {
  return function (values, keySelector) {
    const addItem = new Rx.BehaviorSubject(values || []);
    const removeItem = new Rx.Subject();
    const updateItem = new Rx.Subject();
    const state = new Rx.ReplaySubject();

    keySelector = keySelector || function (item) {
      return item;
    };

    const Operations = {
      AddItem: function (newItem) {
        return function (state) {
          //return state.concat(newItem).unique(keySelector);
          return state.concat(newItem).unique(keySelector);
        };
      },
      RemoveItem: function (itemKey) {
        return function (state) {
          return state.filter(function (item) {
            return keySelector(item) !== itemKey;
          });
        };
      },
      UpdateItem: function (updateItem) {
        return function (state) {
          return state.map(function (item) {
            return keySelector(item) === keySelector(updateItem) ?
                angular.merge(item, updateItem) :
                item;
          });
        };
      }
    };

    const addOperations = addItem.map(function (item) {
      return Operations.AddItem(item);
    });

    const removeOperations = removeItem.map(function (item) {
      return Operations.RemoveItem(item);
    });

    const updateOperations = updateItem.map(function (item) {
      return Operations.UpdateItem(item);
    });

    // Merge our operations into a single stream of operations on state
    const allOperations = Rx.Observable.merge(addOperations, removeOperations, updateOperations);

    // Apply operations to the state
    allOperations
        .scan(function (state, operation) {
          return operation(state);
        }, [])
        .subscribe(state);

    return {
      items: function () {
        return state;
      },
      add: function (value) {

        if (value instanceof Rx.Observable) {
          value.subscribe(function (v) {
            addItem.onNext(v);
          });
        }
        else {
          addItem.onNext(value);
        }
      },
      remove: function (id) {

        if (id instanceof Rx.Observable) {
          id.subscribe(function (i) {
            removeItem.onNext(i);
          });
        }
        else {
          removeItem.onNext(id);
        }

      },
      update: function (value) {

        if (value instanceof Rx.Observable) {
          value.subscribe(function (v) {
            updateItem.onNext(v);
          });
        }
        else {
          updateItem.onNext(value);
        }

      }
    };
  };

}

Array.prototype.unique = function (keySelector) {
  keySelector = keySelector || function (item) {
    return item;
  };

  const a = this.concat();
  for (let i = 0; i < a.length; ++i) {
    for (let j = i + 1; j < a.length; ++j) {
      if (keySelector(a[i]) === keySelector(a[j])) {
        a.splice(i--, 1);
      }
    }
  }

  return a;
};